import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiRouteConstants } from '../../../core/constants/api-routes';
import { ServiceFulfillmentGridRow } from '../models/service-fulfillment-grid-row';
import { Observable } from 'rxjs';
import { UpdateAdvisorRequest } from '../models/update-advisor-request';
import { UpdateWorkflowStateRequest } from '../models/update-workflow-state-request';

@Injectable({
    providedIn: 'root',
})
export class ServiceFulfillmentService {
    private readonly serviceFulfillmentApiRoute =
        ApiRouteConstants.ServiceFulfillment;

    constructor(private readonly http: HttpClient) {}

    getAll(): Observable<ServiceFulfillmentGridRow[]> {
        return this.http.get<ServiceFulfillmentGridRow[]>(
            this.serviceFulfillmentApiRoute.getRootUrl(),
        );
    }

    submitToEwa(applicationId: number): Observable<void> {
        return this.http.post<void>(
            this.serviceFulfillmentApiRoute.getSubmitToEwaUrl(applicationId),
            null,
        );
    }

    updateApplicationWorkflowState(
        request: UpdateWorkflowStateRequest,
    ): Observable<void> {
        return this.http.post<void>(
            this.serviceFulfillmentApiRoute.getUpdateApplicationWorkflowStateUrl(),
            request,
        );
    }

    updateApplicationAdvisor(request: UpdateAdvisorRequest): Observable<void> {
        return this.http.post<void>(
            this.serviceFulfillmentApiRoute.getUpdateApplicationAdvisorUrl(),
            request,
        );
    }
}
